import {
  getFormatedHttpReqError,
  isClient,
} from '@client/shared/utils/utils/utils';
import { showNotification } from '@client/redux/notification/notificationActions';
import { NOTIFICATION_TYPE } from '@client/containers/notificationListing/notification/Notification';

// If Promise.reject we let the node server handle the error (renderUtils.js -> preloadDataErrorHandler)
export function handleApiError(dispatch, error, actionType) {
  if (error?.status === 401) {
    // In the browser, the auth clients have already ended the Session and are
    // sending the user to their own Portal's login page.
    return isClient() ? undefined : Promise.reject(error);
  } else {
    const errorMessage = getFormatedHttpReqError(error);

    dispatch(showNotification(errorMessage, NOTIFICATION_TYPE.WARNING));

    if (actionType) {
      return dispatch({
        type: actionType,
        payload: error,
        error: error,
      });
    }
  }
}
